const getClosestCategoryObj = categories => {
  const result = categories.length > 1 ? [...categories].pop() : {}
  return {
    closestCategoryUuid: result.uuid,
    closestCategoryName: result.name,
  }
}

const getClosestCategoryLabel = categories => {
  const closestCategory = categories.length > 1 ? [...categories].pop() : {}
  let result = []
  if (closestCategory.uuid) {
    result.push(`categoryId=${closestCategory.uuid}`)
  }
  if (closestCategory.name) {
    result.push(`categoryName=${closestCategory.name}`)
  }
  return result
}

export { getClosestCategoryLabel, getClosestCategoryObj }
